import { Directive, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { isModifierKey } from './lib';

import { WInputBase } from './w-input-base';

@Directive({
    host: {
        class: 'b-input',
        '[class.b-input--has-label]': 'hasLabel',
        '[class.b-input--has-content]': 'hasContent()',
        '[class.b-input--has-floating-label]': 'hasLabel && hasContent()',
        '[class.b-input-text]': 'type === "text"',
        '[class.b-input-secret]': 'type === "password"',
        '[class.b-input-email]': 'type === "email"',
    },
    standalone: false
})
// tslint:disable-next-line: directive-class-suffix
export abstract class WInputTextBase extends WInputBase {
    @ViewChild('i') i!: ElementRef<HTMLInputElement>;

    @Input() buttonSize = 'small'; // input icon/action size
    @Input() buttonsAlwaysActive: boolean = false; // buttons not shown disabled even if the field is disabled

    @Output() wChange = new EventEmitter<string>();
    @Output() wKeyup = new EventEmitter<KeyboardEvent>();

    @Input() maxLength: string = ''; // (optional) maximum number of characters, normally enforced by the browser
    @Input() minLength: string = ''; // (optional) minimum number of characters, not enforced, affects the validation
    @Input() pattern: string = ''; // (optional) regex validation, not enforced, affects the validation

    activeIndex: number = -1;

    get hasLabel(): boolean {
        return !!this.label;
    }

    @Input() type = 'text'; // @options [text,email,password]

    capsLockOn: boolean = false;

    hasContent(): boolean {
        return (this.value !== '' && this.value !== undefined); // && this.hasLabel);
    }
    @HostListener('keyup', ['$event'])
    watchCapsLock(event: KeyboardEvent) {
        if (event?.getModifierState) {
            // Chrome bug workaround, missing getModifier state when using autofill
            this.capsLockOn = event?.getModifierState('CapsLock');
        }
    }
    protected handleUpAndDown(event: KeyboardEvent, length: number) {
        try {
            // special treatment - arrows and enter
            if (event.key === 'ArrowDown') {
                this.activeIndex += length > this.activeIndex + 1 ? 1 : 0;
                event.preventDefault();
                return true;
            } else if (event.key === 'ArrowUp') {
                this.activeIndex += this.activeIndex > -1 ? -1 : 0;
                event.preventDefault();
                return true;
            } else if (isModifierKey(event)) {
                // why did we hv disable default(?)
                return true;
            } else {
                return false;
            }
        } catch (e) {
            console.error('Error in handleUpAndDown:', e);
            return false;
        }
    }
    blur() {
        this.i?.nativeElement?.blur();
    }
    focus() {
        this.i?.nativeElement?.focus();
    }
}
